import React, { useEffect, useState, useContext } from "react";
import { Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ReactImageMagnify from "react-image-magnify";
import ZoomImage from "../common/ZoomImage";

import moment from "moment";
import "moment/locale/nl";
import {
  FaExternalLinkAlt,
  FaRegEnvelope,
  FaRegClipboard,
  FaPencilAlt,
  FaTimes,
} from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import { RotateLoader } from "react-spinners";

import saveDeliveryOptionFbrDbb from "../../api/mongodb/update-chosen-delivery-option-fbr-dbb";

import { AuthContext } from "../../context/main/auth-context";
import { downloadBlobFile } from "../../utils/download-blob-file";
import getShippingLabelPdf from "../bol/get-shipping-label-pdf";
import CancelOrderItemModal from "../../components/bol/cancel-order-item-modal";

import flagNetherlands from "../../images/main/flag-netherlands.svg";
import flagBelgium from "../../images/main/flag-belgium.svg";
import postnlBolMailbox from "../../images/shipping/POSTNL-BOL-MAILBOX.png";
import postnlBolParcel from "../../images/shipping/POSTNL-BOL-PARCEL.png";
import postnlBolParcelPickup from "../../images/shipping/POSTNL-BOL-PARCEL-PICKUP.png";
import postnlBolParcelNight from "../../images/shipping/POSTNL-BOL-PARCEL-NIGHT.png";
import dhlBolMailbox from "../../images/shipping/DHL-BOL-MAILBOX.png";
import dhlBolParcel from "../../images/shipping/DHL-BOL-PARCEL.png";
import dhlBolParcelPickup from "../../images/shipping/DHL-BOL-PARCEL-PICKUP.png";
import dhlBolParcelNight from "../../images/shipping/DHL-BOL-PARCEL-NIGHT.png";

import truckIcon from "../../images/main/delivery-truck.svg";
import deadline from "../../images/main/deadline.png";
import siren from "../../images/main/siren.svg";

/* ────────────────────────────────────────────────────────────
   Helpers voor consistente productvelden
   ──────────────────────────────────────────────────────────── */
const getPD = (oi) => oi?.product?.productData || oi?.productData || null;
const getTitle = (oi) =>
  getPD(oi)?.title ||
  oi?.product?.title ||
  oi?.title || // Shopify line-item
  oi?.offer?.reference ||
  "—";

const getEAN = (oi) => oi?.product?.ean || getPD(oi)?.ean || oi?.ean || "";

const getImageKey = (oi) => getPD(oi)?.image || null;

/* ──────────────────────────────────────────────────────────── */

const OrderListItemOpen = (props) => {
  let alreadyRenderedOrderItem = false;

  if (
    props &&
    props.order &&
    props.order.orderItems &&
    props.order.orderItems.length > 0
  ) {
    return props.order.orderItems.map((orderItem, i) => {
      // Als volledig verzonden, niet tonen
      if (
        orderItem.quantityShipped > 0 &&
        orderItem.quantityShipped === orderItem.quantity
      ) {
        orderItem.checked = false;
        return false;
      }

      if (props.order.manualAdded) {
        return (
          <OrderLayOutManualAdded
            order={props.order}
            handleChecked={props.handleChecked}
            orderItem={orderItem}
            key={i}
          />
        );
      } else if (
        props.order.origin?.account?.platform?.toLowerCase() === "bol.com"
      ) {
        if (
          orderItem.fulfilment?.distributionParty?.toLowerCase() === "bol" &&
          props.distributionParty === "DBB"
        ) {
          if (!alreadyRenderedOrderItem) {
            alreadyRenderedOrderItem = true;
            return (
              <OrderLayOutBolOrderVvb
                order={props.order}
                handleChecked={props.handleChecked}
                cancelOrderItem={props.cancelOrderItem}
                setSingleShipOrderConfirmDetails={
                  props.setSingleShipOrderConfirmDetails
                }
                orderItem={orderItem}
                key={i}
                update={props.update}
                cancellationRequestHandler={props.cancellationRequestHandler}
              />
            );
          }
        } else if (
          orderItem.fulfilment?.distributionParty?.toLowerCase() ===
            "retailer" && props.distributionParty === "DBR"
        ) {
          return (
            <OrderLayOutBolOrder
              order={props.order}
              handleChecked={props.handleChecked}
              cancelOrderItem={props.cancelOrderItem}
              cancellationRequestHandler={props.cancellationRequestHandler}
              orderItem={orderItem}
              key={i}
            />
          );
        }
      } else {
        return false;
      }
    });
  } else {
    return false;
  }
};

const OrderLayOutManualAdded = (props) => {
  const auth = useContext(AuthContext);

  const [checked, setChecked] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [showAlertText, setShowAlertText] = useState(false);

  const countryFlag = (() => {
    const c = props.order?.shipmentDetails?.countryCode;
    if (!c) return null;
    if (
      c === "NL" ||
      c?.toLowerCase() === "nederland" ||
      props.order.shipmentDetails?.country?.toLowerCase() === "netherlands"
    ) {
      return <img src={flagNetherlands} alt="NL" />;
    }
    if (
      c === "BE" ||
      c?.toLowerCase() === "belgie" ||
      c?.toLowerCase() === "belgië" ||
      props.order.shipmentDetails?.country?.toLowerCase() === "belgium"
    ) {
      return <img src={flagBelgium} alt="BE" />;
    }
    return c;
  })();

  const imgKey = getImageKey(props?.orderItem);
  const imgUrl = imgKey ? `${process.env.REACT_APP_ASSET_URL}/s3/${imgKey}` : null;

  return (
    <div
      className={`o-li-item o-li-item-open${checked ? " checked" : ""} ${
        props.orderItem.cancellationRequest
          ? " o-li-item-open-cancel-request"
          : ""
      }`}
    >
      <div className="checkbox">
        <Form.Check
          type="checkbox"
          checked={checked}
          onChange={() => {
            const next = !checked;
            setChecked(next);
            props.handleChecked(next, props.order, props.orderItem);
          }}
        />
      </div>
      <div
        className="o-li-item-content"
        onClick={() => {
          const next = !checked;
          setChecked(next);
          props.handleChecked(next, props.order, props.orderItem);
        }}
      >
        <div className="o-li-item-content-header-container">
          <div className="o-li-item-product-title">
            <span className="o-li-item-country-flag-open-order">
              {countryFlag}
            </span>
            {getTitle(props.orderItem)}
            <div>
              Klant: {props.order?.billingDetails?.firstName}{" "}
              {props.order?.billingDetails?.surname}
            </div>
          </div>

          <div className="o-li-item-origin">
            {props.order.additionalOrder && (
              <span className="o-li-item-additional-order-info">
                NAZENDING
                {props.order.additionalOrderReason?.label &&
                  " - " + props.order.additionalOrderReason.label}
              </span>
            )}
            <br />
            GG Bestelnr. {props.order.orderIdGG && props.order.orderIdGG}
          </div>
          <div className="o-li-item-product-title-link">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://www.bol.com/nl/s/?searchtext=${getEAN(
                props.orderItem
              )}`}
            >
              <FaExternalLinkAlt />
            </a>
          </div>
        </div>
        <div className="o-li-item-data">
          <div className="o-li-item-data-item o-li-item-data-item-order-number">
            <label>Bestelnummer</label>
            <span>
              {props.order.orderId && props.order.orderId !== "false"
                ? props.order.orderId
                : props.order.orderIdGG}
            </span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-date">
            <label>Besteldatum</label>
            <span>
              {moment(props.order.orderPlacedDateTime).format("L")}
              <span>{moment(props.order.orderPlacedDateTime).format("LT")}</span>
            </span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-delivery-date">
            <label>
              {props.order.latestDeliveryDate
                ? "Uiterste leverdatum"
                : "Exacte leverdatum"}
            </label>
            <span>
              {props.order.latestDeliveryDate
                ? moment(props.order.latestDeliveryDate).format("LL")
                : null}
            </span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-price">
            <label>Totaalprijs</label>
            <span>
              €{" "}
              {props.orderItem && props.orderItem.total
                ? Number(props.orderItem.total).toFixed(2).replace(".", ",")
                : 0}
            </span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-quantity">
            <label>Aantal</label>
            <span>{props.orderItem.quantity}x</span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-reference">
            <label>Referentie</label>
            <span>{getTitle(props.orderItem)}</span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-image">
            {imgUrl && (
              <ZoomImage
                src={imgUrl}
                thumbnailSrc={imgUrl}
                alt={getTitle(props.orderItem) || "Productafbeelding"}
                className="ship-step3-thumb"
              />
            )}
          </div>
          {props.order.notes && props.order.notes.length > 0 && (
            <div className="o-li-item-data-item o-li-item-data-item-order-notes">
              <label>Notities</label>
              <div className="o-li-item-data-item-order-notes-container">
                {props.order.notes.map((item, idx) => {
                  return (
                    <div key={idx}>
                      <span>{item.user.firstName}:</span>
                      <p>{item.note}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
      {showAlertText && <div className="snackbar">{showAlertText}</div>}
      {loadingPage && (
        <div className="loadingStateContainer">
          <div>
            <div className="sweet-loading processing-page">
              <RotateLoader
                size={100}
                width={100}
                height={10}
                color={"#162954"}
                loading={loadingPage}
              />
              <span className="loadingText">{loadingPage}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const OrderLayOutBolOrder = (props) => {
  const auth = useContext(AuthContext);

  const [checked, setChecked] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [showAlertText, setShowAlertText] = useState(false);

  const countryFlag = (() => {
    const c = props.order?.shipmentDetails?.countryCode;
    if (!c) return null;
    if (c === "NL") return <img src={flagNetherlands} alt="NL" />;
    if (c === "BE") return <img src={flagBelgium} alt="BE" />;
    return c;
  })();

  const imgKey = getImageKey(props?.orderItem);
  const imgUrl = imgKey ? `${process.env.REACT_APP_ASSET_URL}/s3/${imgKey}` : null;

  return (
    <div
      className={`o-li-item o-li-item-open${checked ? " checked" : ""} ${
        props.orderItem.cancellationRequest
          ? " o-li-item-open-cancel-request"
          : ""
      }`}
    >
      <div className="checkbox">
        <Form.Check
          type="checkbox"
          checked={checked}
          onChange={() => {
            const next = !checked;
            setChecked(next);
            props.handleChecked(next, props.order, props.orderItem);
          }}
        />
      </div>
      <div
        className="o-li-item-content"
        onClick={() => {
          const next = !checked;
          setChecked(next);
          props.handleChecked(next, props.order, props.orderItem);
        }}
      >
        <div className="o-li-item-content-header-container">
          <div className="o-li-item-product-title">
            <span className="o-li-item-country-flag-open-order">
              {countryFlag}
            </span>
            {props?.orderItem?.offer?.reference || getTitle(props.orderItem)}
          </div>

          <div className="o-li-item-origin">
            {props.order.origin?.account?.platform +
              " - " +
              props.order.origin?.account?.accountName}
          </div>
          <div className="o-li-item-product-title-link">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://www.bol.com/nl/s/?searchtext=${getEAN(
                props.orderItem
              )}`}
            >
              <FaExternalLinkAlt />
            </a>
          </div>
        </div>
        <div className="o-li-item-data">
          <div className="o-li-item-data-item o-li-item-data-item-order-number">
            <label>Bestelnummer</label>
            <span>{props.order.orderId}</span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-date">
            <label>Besteldatum</label>
            <span>
              {moment(props.order.orderPlacedDateTime).format("L")}
              <span>{moment(props.order.orderPlacedDateTime).format("LT")}</span>
            </span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-delivery-date">
            <label>
              {props.orderItem.fulfilment?.latestDeliveryDate
                ? "Uiterste leverdatum"
                : "Exacte leverdatum"}
            </label>
            <span>
              {props.orderItem.fulfilment?.latestDeliveryDate
                ? moment(props.orderItem.fulfilment.latestDeliveryDate).format(
                    "LL"
                  )
                : moment(props.orderItem.fulfilment?.exactDeliveryDate).format(
                    "L"
                  )}
            </span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-price">
            <label>Totaalprijs</label>
            <span>
              €{" "}
              {(props.orderItem.unitPrice * props.orderItem.quantity)
                .toFixed(2)
                .replace(".", ",")}
            </span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-quantity">
            <label>Aantal</label>
            <span>{props.orderItem.quantity}x</span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-reference">
            <label>Referentie</label>
            <span>{getTitle(props.orderItem)}</span>
          </div>
          <div className="o-li-item-data-item o-li-item-data-item-order-image">
            {imgUrl && (
              <ZoomImage
                src={imgUrl}
                thumbnailSrc={imgUrl}
                alt={getTitle(props.orderItem) || "Productafbeelding"}
                className="ship-step3-thumb"
              />
            )}
          </div>
          {props.orderItem.cancellationRequest && (
            <div className="o-li-item-data-item o-li-item-data-item-cancel-request">
              <Button
                className="cancellationRequest-open-order-button"
                onClick={(e) => {
                  e.stopPropagation();
                  props.cancellationRequestHandler(
                    props.order,
                    props.orderItem
                  );
                }}
              >
                Annulerinsverzoek
              </Button>
            </div>
          )}
        </div>
      </div>
      {showAlertText && <div className="snackbar">{showAlertText}</div>}
      {loadingPage && (
        <div className="loadingStateContainer">
          <div>
            <div className="sweet-loading processing-page">
              <RotateLoader
                size={100}
                width={100}
                height={10}
                color={"#162954"}
                loading={loadingPage}
              />
              <span className="loadingText">{loadingPage}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const OrderLayOutBolOrderVvb = (props) => {
  const auth = useContext(AuthContext);

  const [checked, setChecked] = useState(false);
  const [tempChosenDeliveryOption, setTempChosenDeliveryOption] =
    useState(false);
  const [chosenDeliveryOption, setChosenDeliveryOption] = useState(false);
  const [currentOrderItems, setCurrentOrderItems] = useState(false);
  const [deliveryOptions, setDeliveryOptions] = useState(false);
  const [showDeliveryOptions, setShowDeliveryOptions] = useState(false);
  const [cancelOrderItemModal, setCancelOrderItemModal] = useState(false);
  const [cancelResponse, setCancelResponse] = useState();
  const [loadingPage, setLoadingPage] = useState(false);
  const [showAlertText, setShowAlertText] = useState(false);
  const [processWithCancelRequest, setProcessWithCancelRequest] =
    useState(false);

  // Heeft de order (BOL-items) 1+ annuleringsverzoeken met nog open qty?
  const hasCancelReq =
    Array.isArray(props.order?.orderItems) &&
    props.order.orderItems.some((oi) => {
      const openQty =
        (oi?.quantity || 0) - (oi?.quantityShipped || 0) - (oi?.quantityCancelled || 0);
      return (
        oi?.fulfilment?.distributionParty === "BOL" &&
        oi?.cancellationRequest === true &&
        openQty > 0
      );
    });

useEffect(() => {
  const order = props.order;
  const orderItemId = props.orderItem?.orderItemId;

  if (!order || !Array.isArray(order.deliveryOptions) || !orderItemId) return;

  for (const shipment of order.deliveryOptions) {
    if (!shipment) continue;

    // ✅ Nieuw veld: orderItemRefs (array van {orderItemId, quantity})
    const refIds = Array.isArray(shipment.orderItemRefs)
      ? shipment.orderItemRefs.map((r) => r.orderItemId)
      : [];

    // ✅ Oud veld: orderItemIds (array van strings)
    const oldIds = Array.isArray(shipment.orderItemIds)
      ? shipment.orderItemIds
      : [];

    const allIds = [...refIds, ...oldIds];

    if (allIds.includes(orderItemId)) {
      if (Array.isArray(shipment.options) && shipment.options.length > 0) {
        setDeliveryOptions(shipment.options);
      }
      if (allIds.length > 0) {
        setCurrentOrderItems(allIds);
      }
      if (shipment.chosenOption) {
        setChosenDeliveryOption(shipment.chosenOption);
      } else if (Array.isArray(shipment.options)) {
        const recommended = shipment.options.find((o) => o.recommended === true);
        if (recommended) setChosenDeliveryOption(recommended);
      }
    }
  }
}, [props.order, props.orderItem.orderItemId]);


const deliveryOptionHandler = async () => {
  // 1) Bepaal welke optie we gaan opslaan
  const deliveryOption = tempChosenDeliveryOption || chosenDeliveryOption;

  // Als er niets veranderd is → gewoon sluiten
  if (
    deliveryOption &&
    chosenDeliveryOption &&
    deliveryOption.labelDisplayName === chosenDeliveryOption.labelDisplayName
  ) {
    setShowDeliveryOptions(false);
    return;
  }

  try {
    // 2) Alleen saven als we alles hebben
    if (props.order && currentOrderItems && deliveryOption) {
      await saveDeliveryOptionFbrDbb(
        auth.token,
        props.order,          // mag heel order object zijn
        currentOrderItems,    // array met orderItemIds
        deliveryOption        // gekozen optie
      );
    }

    // 3) UI-state + parent laten weten voor bulk / labels
    setChosenDeliveryOption(deliveryOption);
    props.update && props.update(deliveryOption);
  } catch (err) {
    console.error("Opslaan deliveryOption mislukt:", err);
  } finally {
    setShowDeliveryOptions(false);
  }
};



  const deliveryOptionImgHandler = (deliveryOption) => {
    if (!deliveryOption) return null;
    const label = deliveryOption.toLowerCase();

    if (label.includes("postnl") && label.includes("brievenbus")) {
      return <img src={postnlBolMailbox} alt="PostNL Brievenbus" />;
    }
    if (
      label.includes("postnl") &&
      label.includes("pakket") &&
      label.includes("avond")
    ) {
      return <img src={postnlBolParcelNight} alt="PostNL Avond Pakket" />;
    }
    if (
      label.includes("postnl") &&
      label.includes("pakket") &&
      label.includes("afhaal")
    ) {
      return <img src={postnlBolParcelPickup} alt="PostNL Afhaal Pakket" />;
    }
    if (label.includes("postnl") && label.includes("pakket")) {
      return <img src={postnlBolParcel} alt="PostNL Pakket" />;
    }

    if (label.includes("dhl") && label.includes("brievenbus")) {
      return <img src={dhlBolMailbox} alt="DHL Brievenbus" />;
    }
    if (label.includes("dhl") && label.includes("avond")) {
      return <img src={dhlBolParcelNight} alt="DHL Avond Pakket" />;
    }
    if (label.includes("dhl") && label.includes("afhaal")) {
      return <img src={dhlBolParcelPickup} alt="DHL Afhaal Pakket" />;
    }
    if (label.includes("dhl") && label.includes("pakket")) {
      return <img src={dhlBolParcel} alt="DHL Pakket" />;
    }

    return null; // fallback
  };

  const handoverDateHandler = (isoDateString) => {
    let handoverDate = isoDateString.substring(0, 10);
    let today = new Date().toISOString().substring(0, 10);

    if (today === handoverDate) {
      return "Vandaag";
    } else {
      return moment(handoverDate).locale("nl").format("dddd - DD MMMM");
    }
  };

  const handoverTimeHandler = (isoDateString) => {
    let handoverTime = moment(isoDateString).format("LT");
    return handoverTime;
  };

  const dateIconHandler = (isoDateString) => {
    let handoverDate = isoDateString.substring(0, 10);
    let today = new Date().toISOString().substring(0, 10);
    if (today === handoverDate) {
      return <img src={truckIcon} alt="truckIcon" />;
    } else if (today < handoverDate) {
      return <img src={deadline} alt="deadline" />;
    } else {
      return <img src={siren} alt="deadline" />;
    }
  };

  const downloadShippingLabelHandler = async (shippingLabelId) => {
    const fileName = `${props.order.orderId}-verzendlabel`;
    let account = props.order.origin.account;

    if (!account || !shippingLabelId) return;

    let label = await getShippingLabelPdf(account, auth.token, shippingLabelId);
    downloadBlobFile(label, fileName);
  };

  const cancellationRequestHandler = (oi) => {
    setCancelOrderItemModal({
      auth: auth,
      order: props.order,
      orderItem: oi || props.orderItem,
    });
  };
  let cancelResponseHandler = async (response) => {
    setCancelResponse(response);
    if (response === 202) {
      props.cancelOrderItem(props.order, props.orderItem);
      setShowAlertText("Artikel geannuleerd");
      setTimeout(() => setShowAlertText(false), 3000);
      setCancelResponse(false);
      setLoadingPage(false);
    } else {
      setShowAlertText("Artikel annuleren mislukt");
      setTimeout(() => setShowAlertText(false), 3000);
      setCancelResponse(false);
      setLoadingPage(false);
    }
  };
  const closeCancelOrderItemModalHandler = () => {
    setCancelOrderItemModal(false);
    setLoadingPage(false);
  };

  const animateAlertText = (text) => {
    setShowAlertText(text);
    setTimeout(() => setShowAlertText(false), 3000);
  };

  return (
    props.order && (
      <div className="o-li-item-container-vvb">
        <div className={`o-li-item o-li-item-open-vvb${checked ? " checked" : ""}`}>
          <div className="o-li-item-content-first">
            <div className="o-li-item-content-first-1">
              <div className="checkbox">
                <Form.Check
                  type="checkbox"
                  checked={checked}
                  onChange={() => {
                    setChecked(!checked);
                    props.handleChecked(!checked, props.order, props.orderItem);
                  }}
                  disabled={
                    (!chosenDeliveryOption || !chosenDeliveryOption.entityId) ||
                    (hasCancelReq && !processWithCancelRequest)
                  }
                />
              </div>
            </div>
            <div className="o-li-item-content-first-2">
              <div className="o-li-item-content-first-2-1">
                <div className="o-li-item-content-first-2-1-1">
                  <div className="o-li-item-content-first-2-1-1-1">
                    # {props.order.orderId}
                  </div>
                  <div className="o-li-item-content-first-2-1-1-2">
                    {props.order.origin.account.accountName}
                    <br />
                    {moment(props.order.orderPlacedDateTime).format("L")}
                    <span>
                      {moment(props.order.orderPlacedDateTime).format("LT")}
                    </span>
                  </div>
                  <div className="o-li-item-content-first-2-1-1-3">
                    {(() => {
                      if (props.order.shipmentDetails.countryCode === "NL") {
                        return <img src={flagNetherlands} alt="NL" />;
                      } else if (
                        props.order.shipmentDetails.countryCode === "BE"
                      ) {
                        return <img src={flagBelgium} alt="BE" />;
                      } else {
                        return props.order.shipmentDetails.countryCode;
                      }
                    })()}
                  </div>
                </div>
                <div className="o-li-item-content-first-2-1-2">
                  <div className="o-li-item-content-first-2-1-2-1">
                    {props.order.shipmentDetails.firstName +
                      " " +
                      props.order.shipmentDetails.surname}
                  </div>
                  <div className="o-li-item-content-first-2-1-2-2">
                    <span>
                      <a
                        target="_blank"
                        href={`mailto:${props.order?.shipmentDetails?.email || ""}`}
                        rel="noreferrer"
                      >
                        <FaRegEnvelope />
                      </a>
                    </span>
                  </div>
                  <div className="o-li-item-content-first-2-1-2-3">
                    <span>
                      <CopyToClipboard
                        onCopy={() => {
                          animateAlertText("Gekopieerd");
                        }}
                        text={props.order?.shipmentDetails?.email || ""}
                      >
                        <FaRegClipboard />
                      </CopyToClipboard>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="o-li-item-content-first-3">
              {chosenDeliveryOption && chosenDeliveryOption.labelDisplayName && (
                <div
                  className="o-li-item-content-first-3-1"
                  onClick={() => setShowDeliveryOptions(!showDeliveryOptions)}
                >
                  <div className="o-li-item-content-first-3-1-1">
                    {chosenDeliveryOption &&
                      chosenDeliveryOption.labelDisplayName &&
                      deliveryOptionImgHandler(
                        chosenDeliveryOption.labelDisplayName
                      )}
                  </div>
                  <div className="o-li-item-content-first-3-1-2">
                    {chosenDeliveryOption &&
                      chosenDeliveryOption.labelDisplayName &&
                      chosenDeliveryOption.labelDisplayName}
                    {<FaPencilAlt />}
                  </div>
                </div>
              )}

              {chosenDeliveryOption && chosenDeliveryOption.entityId && (
                <div className="o-li-item-content-first-3-2">
                  <Button
                    onClick={() =>
                      downloadShippingLabelHandler(
                        chosenDeliveryOption.entityId
                      )
                    }
                  >
                    Download verzendzegel
                  </Button>
                </div>
              )}
              {(!chosenDeliveryOption || !chosenDeliveryOption.entityId) && (
                <Button disabled>Verzendzegel wordt aangemaakt</Button>
              )}
            </div>

            {props.order &&
              props.order.orderItems.map((orderItem, idx) => {
                if (orderItem.fulfilment?.distributionParty === "BOL")
                  return (
                    <div
                      key={orderItem.orderItemId ?? `item-${idx}`}
                      className="o-li-item-content-first-4"
                    >
                      <div className="o-li-item-content-first-4-1">
                        {getImageKey(orderItem) ? (
                          <ReactImageMagnify
                            {...{
                              smallImage: {
                                alt: "productimage",
                                isFluidWidth: true,
                                src:
                                  `${process.env.REACT_APP_ASSET_URL}/s3/${getImageKey(orderItem)}`,
                                width: 80,
                                height: 80,
                              },
                              largeImage: {
                                isFluidWidth: true,
                                src:
                                  `${process.env.REACT_APP_ASSET_URL}/s3/${getImageKey(orderItem)}`,
                                width: 250,
                                height: 325,
                              },
                              hoverDelayInMs: 10,
                              hoverOffDelayInMs: 10,
                              enlargedImagePosition: "beside",
                              enlargedImageContainerDimensions: {
                                width: "280%",
                                height: "280%",
                              },
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="o-li-item-content-first-4-2">
                        <div className="o-li-item-content-first-4-1-1">
                          {getTitle(orderItem)}
                        </div>
                        <div className="o-li-item-content-first-4-1-2">
                          <div className="o-li-item-content-first-4-1-2-1">
                            <span>EAN:</span> {getEAN(orderItem)}
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={`https://www.bol.com/nl/s/?searchtext=${getEAN(
                                orderItem
                              )}`}
                            >
                              <FaExternalLinkAlt />
                            </a>
                          </div>
                          <div className="o-li-item-content-first-4-1-2-2">
                            <div className="circle-the-quantity">
                              {orderItem.quantity}x{" "}
                            </div>
                            {getTitle(orderItem)}
                          </div>
                        </div>
                      </div>
                      <div className="o-li-item-content-first-4-3">
                        <div className="o-li-item-content-first-4-2-2">
                          €{" "}
                          {(orderItem.unitPrice * orderItem.quantity)
                            .toFixed(2)
                            .replace(".", ",")}
                        </div>
                        <div className="o-li-item-content-first-4-2-3">
                          <DropdownButton
                            className="cancel-item-dropdown filter-open-orders-dropdown"
                            align="end"
                            id="dropdown-cancel-button"
                            title={<BsThreeDotsVertical />}
                          >
                            <Dropdown.Item
                              onClick={() =>
                                cancellationRequestHandler(orderItem)
                              }
                            >
                              Annuleer bestelling
                            </Dropdown.Item>
                          </DropdownButton>
                        </div>
                      </div>
                    </div>
                  );
                return null;
              })}
          </div>

          <div className="o-li-item-content-second">
            <div className="o-li-item-content-second-1">
              <div className="o-li-item-content-second-1-1">
                {chosenDeliveryOption &&
                  chosenDeliveryOption.handoverDetails &&
                  chosenDeliveryOption.handoverDetails.latestHandoverDateTime &&
                  !hasCancelReq &&
                  dateIconHandler(
                    chosenDeliveryOption.handoverDetails.latestHandoverDateTime
                  )}
                {hasCancelReq && <FaTimes />}
              </div>
              <div className="o-li-item-content-second-1-2">
                {chosenDeliveryOption &&
                  chosenDeliveryOption.handoverDetails &&
                  chosenDeliveryOption.handoverDetails.latestHandoverDateTime &&
                  !hasCancelReq &&
                  handoverDateHandler(
                    chosenDeliveryOption.handoverDetails.latestHandoverDateTime
                  )}
                <br />
                {chosenDeliveryOption &&
                  chosenDeliveryOption.handoverDetails &&
                  chosenDeliveryOption.handoverDetails.latestHandoverDateTime &&
                  !hasCancelReq &&
                  "Wegbrengen tot " +
                    handoverTimeHandler(
                      chosenDeliveryOption.handoverDetails
                        .latestHandoverDateTime
                    )}
              </div>
              <div className="o-li-item-content-second-1-3">
                {hasCancelReq && (
                  <Button
                    className="cancellationRequest-open-order-button"
                    onClick={() => cancellationRequestHandler(props.orderItem)}
                  >
                    Annulerinsverzoek
                  </Button>
                )}
                {hasCancelReq && !processWithCancelRequest && (
                  <div
                    className="continue-processing-with-cancel-request"
                    onClick={() => {
                      setProcessWithCancelRequest(true);
                    }}
                  >
                    Alsnog verwerken?
                  </div>
                )}
                {!hasCancelReq && (
                  <Button
                    onClick={() => {
                      props.setSingleShipOrderConfirmDetails(props.order);
                    }}
                  >
                    verwerken
                  </Button>
                )}
                {hasCancelReq && processWithCancelRequest && (
                  <Button
                    onClick={() => {
                      props.setSingleShipOrderConfirmDetails(props.order);
                    }}
                  >
                    verwerken
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>

        {showDeliveryOptions && (
          <div className="delivery-options-container">
            <div className="delivery-options">
              <div
                className="delivery-options-close-button"
                onClick={() => {
                  setShowDeliveryOptions(false);
                }}
              >
                <FaTimes />
              </div>
              <h1>Verzendzegel wijzigen</h1>
              <div className="delivery-optionsproduct">
                <div className="delivery-options-product-title">
                  {getTitle(props.orderItem)}
                </div>
                <div className="delivery-options-product-details">
                  <span>
                    EAN: {getEAN(props.orderItem)}{" "}
                    <a
                      href={
                        "https://www.bol.com/nl/nl/s/?searchtext=" +
                        getEAN(props.orderItem)
                      }
                      target="_noblank"
                      rel="noreferrer"
                    >
                      <FaExternalLinkAlt />
                    </a>
                  </span>
                  <span>|</span>
                  <span>{getTitle(props.orderItem)} </span>
                  <span>|</span>
                  <span>
                    {props.orderItem.quantity}
                    {props.orderItem.quantity === 1 ? " stuk" : " stuks"}
                  </span>
                  <span>|</span>
                  <span>
                    €{" "}
                    {(props.orderItem.unitPrice * props.orderItem.quantity)
                      .toFixed(2)
                      .replace(".", ",")}
                  </span>
                </div>
              </div>
              <h1 className="label-text-h1">Labels</h1>
              <div className="delivery-options-labels">
                {deliveryOptions &&
                  deliveryOptions.map((deliveryOption, i) => {
                    return (
                      <div className={"radio-toolbar"} key={i}>
                        <Form.Check
                          type="radio"
                          id={deliveryOption.labelDisplayName}
                          name="chooseDeliveryOptions"
                          value={deliveryOption.labelDisplayName}
                          defaultChecked={
                            !!(
                              chosenDeliveryOption &&
                              chosenDeliveryOption.labelDisplayName &&
                              chosenDeliveryOption.labelDisplayName ===
                                deliveryOption.labelDisplayName
                            )
                          }
                          onClick={() => {
                            setTempChosenDeliveryOption(deliveryOption);
                          }}
                          label={
                            <div className="delivery-option-label-info">
                              <div className="delivery-option-label-img">
                                {deliveryOptionImgHandler(
                                  deliveryOption.labelDisplayName
                                )}
                              </div>
                              <div className="delivery-option-data">
                                <div className="delivery-option-name">
                                  {deliveryOption.labelDisplayName}
                                </div>
                                <div className="delivery-option-measurements">
                                  <div>
                                    {"< " +
                                      deliveryOption?.packageRestrictions
                                        ?.maxWeight}
                                  </div>
                                  <div className="divider">|</div>
                                  <div>
                                    {"< " +
                                      deliveryOption?.packageRestrictions
                                        ?.maxDimensions}
                                  </div>
                                </div>
                              </div>
                              <div className="delivery-option-price">
                                €{" "}
                                {deliveryOption?.labelPrice.totalPrice
                                  .toFixed(2)
                                  .replace(".", ",")}
                                *
                              </div>
                            </div>
                          }
                        />
                      </div>
                    );
                  })}
              </div>
              <div className="delivery-option-label-extra-info">
                * Excl. eventueel verschuldigde btw. De zegelkosten verrekenen
                we automatisch met je opbrengst.
              </div>
              <div className="delivery-option-buttons">
                <Button
                  onClick={() => {
                    setShowDeliveryOptions(false);
                  }}
                >
                  Annuleer
                </Button>
                <Button
                  onClick={() => {
                    deliveryOptionHandler();
                  }}
                >
                  Wijzigingen opslaan
                </Button>
              </div>
            </div>
          </div>
        )}
        {cancelOrderItemModal && !cancelResponse && (
          <CancelOrderItemModal
            cancelData={cancelOrderItemModal}
            cancelResponseHandler={cancelResponseHandler}
            closeCancelOrderItemModal={closeCancelOrderItemModalHandler}
            loadingStateCancel={() => {
              setLoadingPage("Artikel wordt geannuleerd.");
              setCancelOrderItemModal(false);
            }}
          />
        )}
        {showAlertText && <div className="snackbar">{showAlertText}</div>}
        {loadingPage && (
          <div className="loadingStateContainer">
            <div>
              <div className="sweet-loading processing-page">
                <RotateLoader
                  size={100}
                  width={100}
                  height={10}
                  color={"#162954"}
                  loading={loadingPage}
                />
                <span className="loadingText">{loadingPage}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default OrderListItemOpen;